import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KanbanContainerComponent } from './kanban-container/kanban-container.component';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatChipsModule } from '@angular/material/chips';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { KanbanHeaderComponent } from './kanban-header/kanban-header.component';
import { KanbanBodyComponent } from './kanban-body/kanban-body.component';
import { KanbanHeaderGridComponent } from './kanban-header-grid/kanban-header-grid.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { KanbanSearchAdvancedComponent } from './kanban-search-advanced/kanban-search-advanced.component';
import { KanbanSearchSavedComponent } from './kanban-search-saved/kanban-search-saved.component';
import { KanbanSearchTagFilterDataComponent } from './kanban-search-tag-filter-data/kanban-search-tag-filter-data.component';
import { KanbanSearchAdvancedFormComponent } from './kanban-search-advanced-form/kanban-search-advanced-form.component';
import { FlexLayoutModule } from "@angular/flex-layout";
import { KanbanSearchContainerComponent } from './kanban-search-container/kanban-search-container.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import { KanbanOrderListViewComponent } from './kanban-list-view/kanban-list-view.component';
import { KanbanViewContainerComponent } from './kanban-view-container/kanban-view-container.component';
import { KanbanViewCardComponent } from './kanban-view-card/kanban-view-card.component';
import { KanbanAddEditSwimLaneComponent } from './kanban-add-edit-swimlane/kanban-add-edit-swimlane.component';
import { MatDialogModule } from '@angular/material/dialog';
import { KanbanFilterBarComponent } from './kanban-filter-bar/kanban-filter-bar.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { OrderColumnNameMapperPipe } from './pipes/order-column-name-mapper.pipe';
import { KanbanAddSavedSearchModalComponent } from './kanban-add-saved-search-modal/kanban-add-saved-search-modal.component';
import { KanbanSearchCardComponent } from './kanban-search-card/kanban-search-card.component';
import { KanbanConfirmationModalComponent } from './kanban-confirmation-modal/kanban-confirmation-modal.component';
import { KanbanSavedSearchBarComponent } from './kanban-saved-search-bar/kanban-saved-search-bar.component';
import { MatSortModule } from '@angular/material/sort';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { KanbanActionsBarComponent } from './kanban-actions-bar/kanban-actions-bar.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { KanbanAccountListViewComponent } from './kanban-account-list-view/kanban-account-list-view.component';
import { KanbanArtworkListViewComponent } from './kanban-artwork-list-view/kanban-artwork-list-view.component';
import { KanbanProductsListComponent } from './kanban-products-list/kanban-products-list.component';
import { KanbanSearchComponent } from './kanban-search/kanban-search.component';
import { KanbanProductThumbnailViewComponent } from './kanban-product-thumbnail-view/kanban-product-thumbnail-view.component';
import { ProductionKanbanViewContainerComponent } from './production-kanban-view-container/production-kanban-view-container.component';
import { ProductionKanbanViewCardComponent } from './production-kanban-view-card/production-kanban-view-card.component';
import { KanbanProductionMachineDialogComponent } from './kanban-production-machine-dialog/kanban-production-machine-dialog.component';
import { ProductionKanbanMachineViewContainerComponent } from './production-kanban-machine-view-container/production-kanban-machine-view-container.component';
import { ProductionKanbanMachineViewCardComponent } from './production-kanban-machine-view-card/production-kanban-machine-view-card.component';
import { KanbanProductionCalendarDialogComponent } from './kanban-production-calendar-dialog/kanban-production-calendar-dialog.component';
import { KanbanProductionsListViewComponent } from './kanban-productions-list-view/kanban-productions-list-view.component';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { OrdersKanbanViewContainerComponent } from './orders-kanban-view-container/orders-kanban-view-container.component';
import { OrdersKanbanViewCardComponent } from './orders-kanban-view-card/orders-kanban-view-card.component';
import { KanbanProductionViewComponent } from './kanban-production-view/kanban-production-view.component';
import { KanbanProductionViewCardComponent } from './kanban-production-view-card/kanban-production-view-card.component';
import { KanbanLeadsListViewComponent } from './kanban-leads-list-view/kanban-leads-list-view.component';
import { ProductKanbanViewComponent } from './product-kanban-view/product-kanban-view.component';
import { ProductKanbanViewCardComponent } from './product-kanban-view-card/product-kanban-view-card.component';
import { KanbanLeadsViewContainerComponent } from './kanban-leads-view-container/kanban-leads-view-container.component';
import { KanbanLeadsViewCardComponent } from './kanban-leads-view-card/kanban-leads-view-card.component';
import { OpportunitiesListViewComponent } from './opportunities-list-view/opportunities-list-view.component';
import { OpportunitiesKanbanViewContainerComponent } from './opportunities-kanban-view-container/opportunities-kanban-view-container.component';
import { OpportunitiesKanbanViewCardComponent } from './opportunities-kanban-view-card/opportunities-kanban-view-card.component';
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { QuoteViewContainerComponent } from './quote-view-container/quote-view-container.component';
import { QuoteViewCardComponent } from './quote-view-card/quote-view-card.component';
import { AccountKanbanViewContainerComponent } from './account-kanban-view-container/account-kanban-view-container.component';
import { AccountKanbanViewCardComponent } from './account-kanban-view-card/account-kanban-view-card.component';
import { ContactListViewComponent } from './contact-list-view/contact-list-view.component';
import { ContactsKanbanContainerViewComponent } from './contacts-kanban-container-view/contacts-kanban-container-view.component';
import { ContactsKanbanCardViewComponent } from './contacts-kanban-card-view/contacts-kanban-card-view.component';
import { NgxDnDModule } from '@swimlane/ngx-dnd';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    FormsModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatRadioModule,
    MatSelectModule,
    MatTabsModule,
    MatTableModule,
    MatTooltipModule,
    MatDividerModule,
    MatToolbarModule,
    FlexLayoutModule,
    MatSidenavModule,
    MatDialogModule,
    MatPaginatorModule,
    MatSortModule,
    DragDropModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonToggleModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    NgxDnDModule 
  ],
  declarations: [
    KanbanContainerComponent,
    KanbanHeaderComponent,
    KanbanBodyComponent,
    KanbanHeaderGridComponent,
    KanbanSearchComponent,
    KanbanSearchAdvancedComponent,
    KanbanSearchSavedComponent,
    KanbanSearchTagFilterDataComponent,
    KanbanSearchAdvancedFormComponent,
    KanbanSearchContainerComponent,
    KanbanOrderListViewComponent,
    KanbanViewContainerComponent,
    KanbanViewCardComponent,
    KanbanAddEditSwimLaneComponent,
    KanbanFilterBarComponent,
    OrderColumnNameMapperPipe,
    KanbanAddSavedSearchModalComponent,
    KanbanSearchCardComponent,
    KanbanConfirmationModalComponent,
    KanbanSavedSearchBarComponent,
    KanbanActionsBarComponent,
    KanbanAccountListViewComponent,
    KanbanArtworkListViewComponent,
    KanbanProductsListComponent,
    KanbanProductThumbnailViewComponent,
    ProductionKanbanViewContainerComponent,
    ProductionKanbanViewCardComponent,
    ProductionKanbanViewCardComponent,
    KanbanProductionMachineDialogComponent,
    ProductionKanbanMachineViewContainerComponent,
    ProductionKanbanMachineViewCardComponent,
    KanbanProductionCalendarDialogComponent,
    KanbanProductionsListViewComponent,
    OrdersKanbanViewContainerComponent,
    OrdersKanbanViewCardComponent,
    KanbanProductionViewComponent,
    KanbanProductionViewCardComponent,
    KanbanLeadsListViewComponent,
    ProductKanbanViewComponent,
    ProductKanbanViewCardComponent,
    KanbanLeadsViewContainerComponent,
    KanbanLeadsViewCardComponent,
    OpportunitiesListViewComponent,
    OpportunitiesKanbanViewContainerComponent,
    OpportunitiesKanbanViewCardComponent,
    QuoteViewContainerComponent,
    QuoteViewCardComponent,
    AccountKanbanViewContainerComponent,
    AccountKanbanViewCardComponent,
    ContactListViewComponent,
    ContactsKanbanContainerViewComponent,
    ContactsKanbanCardViewComponent

  ],
  exports: [
    KanbanContainerComponent,
    KanbanHeaderComponent,
    KanbanBodyComponent,
    KanbanHeaderGridComponent,
    KanbanSearchComponent,
    KanbanSearchAdvancedComponent,
    KanbanSearchSavedComponent,
    KanbanSearchTagFilterDataComponent,
    KanbanSearchAdvancedFormComponent,
    KanbanSearchContainerComponent,
    KanbanOrderListViewComponent,
    KanbanViewContainerComponent,
    KanbanViewCardComponent,
    KanbanAddEditSwimLaneComponent,
    KanbanFilterBarComponent,
    OrderColumnNameMapperPipe,
    KanbanAddSavedSearchModalComponent,
    KanbanSearchCardComponent,
    KanbanConfirmationModalComponent,
    KanbanSavedSearchBarComponent,
    KanbanActionsBarComponent,
    KanbanAccountListViewComponent,
    KanbanArtworkListViewComponent,
    KanbanProductsListComponent,
    KanbanProductThumbnailViewComponent,
    ProductionKanbanViewContainerComponent,
    ProductionKanbanViewCardComponent,
    ProductionKanbanMachineViewContainerComponent,
    ProductionKanbanMachineViewCardComponent,
    KanbanProductionsListViewComponent,
    OrdersKanbanViewContainerComponent,
    OrdersKanbanViewCardComponent,
    KanbanProductionViewComponent,
    KanbanProductionViewCardComponent,
    KanbanLeadsListViewComponent,
    ProductKanbanViewComponent,
    ProductKanbanViewCardComponent,
    KanbanLeadsViewContainerComponent,
    KanbanLeadsViewCardComponent,
    OpportunitiesListViewComponent,
    OpportunitiesKanbanViewContainerComponent,
    OpportunitiesKanbanViewCardComponent,
    QuoteViewContainerComponent,
    QuoteViewCardComponent,
    AccountKanbanViewContainerComponent,
    AccountKanbanViewCardComponent,
    ContactListViewComponent,
    ContactsKanbanContainerViewComponent,
    ContactsKanbanCardViewComponent
  ],
  entryComponents: [
    KanbanConfirmationModalComponent,
    KanbanAddSavedSearchModalComponent
  ]
})
export class KanbanModule {}
